import { defineMessages } from "react-intl";

const PREFIX = "Favourites.FavouriteItemsTree";

export const messages = defineMessages({
  slidesGroup: {
    id: `${PREFIX}.slidesGroup`,
    defaultMessage: "Slides",
  },
  mapsGroup: {
    id: `${PREFIX}.mapsGroup`,
    defaultMessage: "Maps",
  },
  bulkExportGroup: {
    id: `${PREFIX}.bulkExportGroup`,
    defaultMessage: "Bulk export",
  },
  savedBulkExportGroup: {
    id: `${PREFIX}.savedBulkExportGroup`,
    defaultMessage: "Saved bulk export",
  },
});
